export interface ModuleData {
  label: string;
  unitLabel: string;
  isChecked: boolean;
  userCount: number;
  limitType: "Limited" | "Unlimited";
}

export const mockModulesData: ModuleData[] = [
  {
    label: "Users",
    unitLabel: "user(s)",
    isChecked: true,
    userCount: 10,
    limitType: "Limited",
  },
  {
    label: "Devices",
    unitLabel: "device(s)",
    isChecked: false,
    userCount: 5,
    limitType: "Limited",
  },
  {
    label: "Reports",
    unitLabel: "report(s)",
    isChecked: true,
    userCount: 25,
    limitType: "Unlimited",
  },
  {
    label: "Integrations",
    unitLabel: "integration(s)",
    isChecked: true,
    userCount: 3,
    limitType: "Limited",
  },
  {
    label: "Storage",
    unitLabel: "GB",
    isChecked: false,
    userCount: 100,
    limitType: "Limited",
  },
];

